<div class="tw-relative">
  <div class="tw-bg-orange-25 tw-rounded-tl-4 tw-rounded-tr-4 tw-pt-16 tw-pb-4">
    <img class="tw-absolute tw-left-1/2 tw-top-0 tw-transform -tw-translate-x-1/2 -tw-translate-y-1/2 tw-w-[112px] tw-h-[112px] tw-rounded-full tw-object-contain" [src]="data.allocatedDoctorImage" />
    <p class="tw-font-bold tw-font-lexend tw-text-500 tw-text-black tw-text-center" i18n="@@toUnlockMoreDoctorCheckups">To unlock more doctor check-ups</p>
    <p class="tw-font-normal tw-font-lexend tw-text-500 tw-text-black tw-text-center" i18n="@@reOrderYourTreatmentProducts">re-order your treatment products</p>
  </div>
  <div class="tw-absolute tw-flex tw-justify-center tw-items-center tw-z-[100] tw-top-[14px] tw-right-[14px] tw-p-1 tw-rounded-full" (click)="closeBottomSheet()">
    <div class="tw-text-black tw-font-bold tw-flex tw-items-center tw-justify-center" style="font-size: 16px; line-height: 1;">&#10005;</div>
  </div>
  <div class="tw-flex tw-gap-2 tw-py-6 tw-px-4 tw-overflow-x-auto">
    <app-product-card *ngFor="let product of data.products; let i = index" [productInCart]="selectedProducts[i].quantity" [product]="product" [size]="'sm'" [variant]="'bottomsheet'" (addToCart)="addProduct($event)" (reomveFromCart)="removeProduct($event)">
      @if (product?.isPurchasedInLast30Days) {
        <div class="tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-flex tw-items-center tw-justify-center tw-gap-1 tw-py-1 tw-rounded-br-2 tw-rounded-bl-2 tw-bg-gradient-white-to-teal-solid tw-font-body tw-font-bold tw-text-50 tw-text-teal-500">
          <p style="line-height: normal;" i18n="@@recentlyBought">Recently Bought</p>
        </div>
      } @else {
        <div class="tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-flex tw-items-center tw-justify-center tw-gap-[2px] tw-py-1 tw-rounded-br-2 tw-rounded-bl-2 tw-bg-orange-100 tw-font-body tw-font-bold tw-text-50 tw-text-orange-500">
          <span style="line-height: normal;" i18n="@@drAdded">
            Dr. Added
          </span>
        </div>
      }
    </app-product-card>
  </div>
  <div class="tw-px-4 tw-pt-4 tw-pb-5 tw-shadow-z11">
    @if (data?.showCoupon) {
      <div class="tw-relative tw-flex tw-items-center tw-gap-2 tw-py-[7px] tw-bg-gray-100 tw-pl-2 tw-rounded-2 tw-mb-6" [ngClass]="{'cart-page-bg-gradient': isCouponApplied}">
        <div class="tw-w-4 tw-h-4 tw-cursor-pointer tw-flex tw-items-center tw-justify-center tw-transition-transform tw-duration-200" (click)="toggleCoupon()" [attr.aria-checked]="isCouponApplied" role="checkbox" tabindex="0">
          @if (isCouponApplied) {
            <cs-icon class="tw-h-4 tw-w-4" [iconName]="'rebranding/v1/teal_checkbox'"></cs-icon>
          } @else {
            <div class="tw-w-4 tw-h-4 tw-border-[1px] tw-border-solid tw-border-gray-400 tw-rounded-1 tw-bg-white"></div>
          }
        </div>
        @if (isCouponApplied) {
          <div class="tw-font-body tw-text-200 tw-text-gray-800">
            <span class="tw-font-bold" i18n="@@regimenCouponApplied">Coupon Applied! </span>
            <span class="tw-font-medium" i18n="@@youJustSaved">You just saved ₹{{data?.couponDetails?.amount}}.</span>
          </div>
        } @else {
          <div class="tw-font-body tw-text-200">
            <span class="tw-font-bold" i18n="@@clickHereToGetExtraOff">Click here to get extra ₹{{data?.couponDetails?.amount}} Off</span>
          </div>
        }
        <div *ngIf="showConfetti" class="tw-absolute tw-right-2 tw-top-1/2 tw-transform -tw-translate-y-1/2 tw-z-30 tw-pointer-events-none">
          <img src="https://cdn.cureskin.com/app/img/coupon.gif" alt="Confetti Animation" class="tw-w-16 tw-h-16 tw-object-contain" style="mix-blend-mode: multiply;" />
        </div>
      </div>
    }

    <button 
      class="tw-border-none tw-w-full tw-h-10 tw-relative tw-text-gray-50 tw-text-[18px] tw-capitalize tw-p-4 tw-overflow-visible tw-mb-2 tw-rounded-3" 
      [ngClass]="{
        'shine loop tw-bg-teal-600': isCtaEnabled,
        'tw-bg-gray-400 tw-cursor-not-allowed': !isCtaEnabled
      }"
      [disabled]="!isCtaEnabled"
      (click)="buyNow()">
      @if (isCtaEnabled && discountPercentage > 0) {
        <div class="tw-absolute tw-flex tw-items-center tw-justify-center tw-top-[-15px] tw-left-[10px] tw-text-orange-400">
          <svg class="tw-w-16 tw-h-16 tw-relative tw-animate-spin_slow" xmlns="http://www.w3.org/2000/svg" width="64.443" height="67.447" viewBox="0 0 64.443 67.447">
            <path id="Path_23051" data-name="Path 23051" d="M87.025,208.059,79.5,203.146l-2.347-8.676a3.039,3.039,0,0,0-3.088-2.243l-8.976.449-7-5.639a3.042,3.042,0,0,0-3.817,0l-7,5.639-8.975-.449a3.031,3.031,0,0,0-3.088,2.243l-2.347,8.676-7.525,4.912a3.042,3.042,0,0,0-1.179,3.63l3.2,8.4-3.2,8.4a3.042,3.042,0,0,0,1.179,3.63l7.525,4.913,2.347,8.675a3.034,3.034,0,0,0,3.088,2.243l8.975-.449,7,5.639a3.041,3.041,0,0,0,3.817,0l7-5.639,8.976.449a3.036,3.036,0,0,0,3.088-2.243l2.347-8.675,7.525-4.913a3.042,3.042,0,0,0,1.179-3.63l-3.2-8.4,3.2-8.4A3.042,3.042,0,0,0,87.025,208.059Z" transform="translate(-23.961 -186.363)" fill="#D66736"></path>
          </svg>
          <span class="tw-absolute tw-text-500 tw-text-white tw-uppercase tw-z-20 tw-font-bold tw-leading-none">{{discountPercentage}}% <br />off </span>
        </div>
      }
      <span class="tw-font-lexend tw-font-bold tw-text-400 tw-leading-[20px]" [ngClass]="(isCtaEnabled && discountPercentage > 0) ? 'tw-ml-[52px]' : 'tw-ml-0'">
        <span i18n="@@buyNow">Buy Now</span>
        @if (totalMRP > 0 && totalMRP > totalSP) {
          <span> &#64;</span>
          <span class="tw-text-200  tw-line-through" >₹{{totalMRP}}</span>
        }
        @if (totalSP > 0) {
          <span> ₹{{totalSP}}</span>
        }
      </span>
    </button>
    

  </div>
</div>
